import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "region-dashboards-rating-list" }
const _hoisted_2 = { class: "region-dashboards-rating-list__position" }
const _hoisted_3 = { class: "region-dashboards-rating-list__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "region-dashboards-rating-list__loader"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getPreparedRatingList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["region-dashboards-rating-list__item", {
        'region-dashboards-rating-list__item--active': item.id === _ctx.currentItemId,
      }]),
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.position), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)
          ], 2))
        }), 128))
  ]))
}